export async function transcribeAudio(blob: Blob): Promise<string> {
  const response = await fetch("/api/transcribe", {
    method: "POST",
    headers: { "Content-Type": blob.type || "application/octet-stream" },
    body: blob,
  });
  if (!response.ok) {
    throw new Error(`Transcribe failed: ${response.status}`);
  }
  const data = (await response.json()) as { text?: string };
  return (data.text ?? "").trim();
}
